import React from "react";

// Styles \\
import "../../assets/styles/cards/freeCheckCard.scss";

// Images \\
import doctors from "../../assets/images/service_doctor.svg";

const FreeCheckCard = () => {
  return (
    <div>
      <div className="card">
        <div className="card_items">
          <div className="card_items_content">
            <div className="card_items_title">
              <h3>A passion for putting patients first.</h3>
            </div>
            <div className="card_items_services">
              <div className="card_items_services_parts">
                <div className="parts">
                  <div className="dot"></div>
                  <div className="content">A Passion for Healing</div>
                </div>
                <div className="parts">
                  <div className="dot"></div>
                  <div className="content">All our best</div>
                </div>
                <div className="parts">
                  <div className="dot"></div>
                  <div className="content">A Legacy of Excellence</div>
                </div>
              </div>
              <div className="card_items_services_parts">
                <div className="parts">
                  <div className="dot"></div>
                  <div className="content">5-Star Care</div>
                </div>
                <div className="parts">
                  <div className="dot"></div>
                  <div className="content">Believe in Us</div>
                </div>
                <div className="parts">
                  <div className="dot"></div>
                  <div className="content">Always Caring</div>
                </div>
              </div>
            </div>

            <div className="card_items_desc">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim et.
              </p>
              <p className="second">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque. Convallis felis vitae tortor augue. Velit
                nascetur proin massa in.
              </p>
              <p className="second">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque. Convallis felis vitae tortor augue. Velit
                nascetur proin massa in.
              </p>
            </div>
          </div>

          <div className="card_items_images">
            <div className="image odd">
              <img src={doctors} alt="" />
            </div>
            <div className="image">
              <img src={doctors} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeCheckCard;
